import { AppSettings } from '../settings';

let appSettings: AppSettings | null = null;

function getAppSettings() {
	if (appSettings === null) {
		// eslint-disable-next-line no-underscore-dangle
		appSettings = JSON.parse(window.pushpay.__SETTINGS__);
	}

	return appSettings as AppSettings;
}

export default getAppSettings;
